const TypesDuration = [
    {
        value: "day",
        text: "Last day",
    }, 
    {
        value: "week",
        text: "Last week",
    },
    {
        value: "month",
        text: "Last month",
    },
    {
        value: "year",
        text: "Last year",
    },
    {
        value: "all",
        text: "All time",
    }
]

export default TypesDuration;